<template>
  <div>
    <div class="split-box">
      <div class="split-line"></div>
      <div class="split-name">【项目状态】</div>
    </div>
    <div class="view-row">
      <div class="view-field">
        <div class="view-label" style="line-height: 40px">项目状态</div>
        <div class="view-val">
          <el-select v-model="status" :clearable="true" placeholder="请选择">
            <el-option
              v-for="item in projectStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <div style="padding-left: 20px; display: inline-block">
            <el-button type="primary" @click="updateProjectStatus"
              >保存</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
export default {
  name: "ProjectStatus",
  props: { projectid: Number, projectstatus: String },
  data() {
    return {
      status: this.projectstatus,
      projectStatusList: [],
    };
  },
  watch:{
    projectstatus(nval,oval){
      this.status = nval
    }
  },
  async activated() {
    await this.getProjectStatusList();
  },
  methods: {
    async getProjectStatusList() {
      this.projectStatusList = await request({
        url: "/kfgl/syscode/getSysCodeList",
        method: "get",
        params: { syscode: "projectstatus" },
      });
    },
    async updateProjectStatus() {
      this.$confirm("是否确定", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let res = await request({
            url: "/xtgl/status/updateProjectStatus",
            method: "post",
            data: {
              projectstatus: this.status,
              projectid: this.projectid,
            },
          });
          if (+res.issuccess === 1) {
            this.$message.success("更新成功");
            this.getModel();
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.split-box {
  margin: 11px 0 15px;
  .split-line {
    margin: 5px;
  }
  .split-name {
    font-weight: bold;
  }
}
</style>
